export const chats = {
  chatListChatIfoAttachmentsText: 'Надіслано вкладення',
  chatListChatNoMessagesText: 'Повідомлень поки що немає',
  chatArchivedTitle: 'Архів чатів',
  chatsCreatePrivateCurtainTitle: 'Новий чат',
  chatsCreatePrivateCurtaiSearchInputPlaceholder: 'Пошук',
  chatsCreatePrivateCurtainCreateButtonTitle: 'Створити',
  chatCreateButtonTitle: 'Далі',
  chatCreateNewGroupHeader: 'Нова група',
  chatGroupNameInputTitle: 'Назва групи',
  chatLogoTitle: 'Змінити',
  chatCreateGroupButtonTitle: 'Створити групу',
  chatRequiredFieldsAlert: 'Вкажіть назву групи!',
  chatsCreateGroupChatLongTitleAlertText: 'Назва занадто довга!',
  chatsCreateGroupChatLBigImageAlertText: 'Зображення занадто велике!',
  chatsNewChatInputPlaceholder: 'Написати повідомлення',
  chatsNewChatAddedBigImageAlertText: 'Зображення занадто велике!',
  chatOwnersArchiveOptionText: 'Перемістити в архів',
  chatOwnersEditGroupOptionText: 'Змінити',
  chatOwnersManageGroupOptionText: 'Список учасників',
  chatOwnersChangeGroupOptionText: 'Змінити власника групи',
  chatOwnersLeaveGroupOptionText: 'Покинути чат',
  chatOwnersDeleteGroupOptionText: 'Видалити чат',
  chatpopupArchivedTitle: 'Додати в архів',
  chatpopupArchivedDescription: 'Ви впевнені?',
  chatArchiveGroupButtonTitleYes: 'Підтвердити',
  chatArchiveGroupButtonTitleCancel: 'Скасувати',
  chatEditGroupHeader: 'Редагувати чат',
  chatEditGroupEditLogoTitle: 'Змінити',
  chatEditGroupButtonTitle: 'Зберегти',
  chatGroupEditAlertText: 'Успішно збережено!',
  chatManageGroupHeader: 'Список учасників',
  chatManageGroupButtonTitle: 'Додати учасника',
  chatManageGroupSaveButtonTitle: 'Зберегти',
  chatAddUsersGroupHeader: 'Додати учасників',
  chatAddUsersGroupButtonTitle: 'Підтвердити',
  chatAddUsersGroupSearchInputPlaceholder: 'Пошук',
  chatOwnershipTransferHeader: 'Зміна власника',
  chatOwnershipTransferSearchInputPlaceholder: 'Пошук',
  chatOwnershipTransferButtonTitle: 'Підтвердити',
  chatOwnerMarkText: '(Ви)',
  chatOwnershipTransferAlertText: 'Власника змінено!',
  chatOwnerLeaveGroupTitle: 'Покинути чат',
  chatOwnerLeaveGroupDescription: 'Ви є власником групи, тому потрібно спочатку обрати нового власника.',
  chatOwnerLeaveGroupButtonTitleYes: 'Обрати',
  chatOwnerLeaveGroupButtonTitleNo: 'Скасувати',
  chatsGroupChatUsersCurtanArchOptionTitle: 'Перемістити в архів',
  chatsGroupChatUsersCurtanMembersOptionTitle: 'Учасники чату',
  chatsGroupChatUsersCurtanLeaveOptionTitle: 'Покинути чат',
  chatsGroupChatMemberCurtainTitle: 'Учасники чату',
  chatsGroupChatMemberCurtainSearchInputPlaceholder: 'Пошук',
  chatsGroupChatMemberCurtainOwnerMarkText: '(власник)',
  chatsGroupChatLeavePopupTitle: 'Покинути чат',
  chatsGroupChatLeavePopupText: 'Ви впевнені?',
  chatsGroupChatLeavePopupCancelButtonTitle: 'Скасувати',
  chatsGroupChatLeavePopupConfirmButtonTitle: 'Підтвердити',
  chatDeleteGroupTitle: 'Видалити чат',
  chatDeleteGroupDescription: 'Чат та вся історія чату буде видалена для всіх його учасників, продовжити?',
  chatDeleteGroupButtonTitleYes: 'Підтвердити',
  chatDeleteGroupButtonTitleNo: 'Скасувати',
  chatsPrivateChatCurtainArchOptionTitle: 'Перемістити в архів',
  chatsEditMessage: 'Редагувати повідомлення',
  chatsCopyMessage: 'Копіювати повідомлення',
  chatsDeleteMessage: 'Видалити повідомлення',
  chatsSelectMessage: 'Виділити повідомлення',
  chatMarkTextEdit: '(відредаговано)',
  chatCopyMessageAlertText: 'Повідомлення скопійовано!',
  chatDeleteMessageTitle: 'Видалити повідомлення',
  chatDeleteMessageDescription: 'Видалити це повідомлення?',
  chatDeleteMessageButtonTitleYes: 'Підтвердити',
  chatDeleteMessageButtonTitleNo: 'Скасувати',
  chatSelectButtonDelete: 'Скасувати',
  chatSelectButtonNo: 'Видалити',
  chatDeleteMessagesTitle: 'Видалити повідомлення',
  chatDeleteMessagesDescription: 'Видалити ці повідомлення?',
  chatDeleteMessagesButtonTitleYes: 'Підтвердити',
  chatDeleteMessagesButtonTitleNo: 'Скасувати',
  chatArchiveButtonRestore: 'Відновити',
  chatArchiveButtonNo: 'Видалити',
  chatNoUsersCurtainTitle: 'Лишенько!',
  chatsNoUsersCurtainText: 'Здається, що наразі ви єдиний користувач застосунку. Запросіть друзів, щоб почати спілкуватися.',
  chatsNoUsersCurtainCancelButtonTitle: 'Скасувати',
  chatsNoUsersCurtainCopyButtonTitle: 'Запросити',
  chatsAppLinkCopiedAlertText: 'Посилання скопійовано!',
  chatsTooFewUsers: 'Для створення чату потрібно обрати хоча б одного користувача!',
  chatsError: 'Щось пішло не так!'
}
